module.exports = __webpack_public_path__ + "media/images/dailySpecialMarker@3x-0683e10227f59bdfcaf5e85e860704bc.png";